import React from 'react';
import { Waypoint } from 'react-waypoint';

import ProductShortInfo from '../product-short-info/ProductShortInfo';

import useStyles from 'pages/widget/components/general-accommodations-list/styles';

const GeneralRentalItemsList = ({ rentalItems, page, fetchData, perPage, selectProduct, initialSelectedCurrency }) => {
  const classes = useStyles();

  if (!rentalItems?.length) return null;

  return (
    <div className={classes.wrapper}>
      {rentalItems.map((item, index) => (
        <div className={classes.item} key={index}>
          <div>
            <ProductShortInfo
              item={item}
              initialSelectedCurrency={initialSelectedCurrency}
              isPrices={false}
              isRentalPrices={true}
              isRightArrow={true}
              selectProduct={selectProduct}
            />
          </div>
          {(page < perPage) && (index === rentalItems.length - 2) && (
            <Waypoint onEnter={() => fetchData(page + 1)} />
          )}
        </div>
      ))}
      <div className={classes.afterElement}>{''}</div>
      <div className={classes.afterElement}>{''}</div>
    </div>
  );
};

export default GeneralRentalItemsList;
